import { Component, EventEmitter, Input, Output } from '@angular/core';
import { APP_ROUTES as ROUTES } from '@app/app.routes';
import { UtilService } from '@app/services/util.service';
import { AppFacade } from '@app/facades/app.facade';

@Component({
  selector: 'layout-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  public clickEvent: boolean = false;
  public closeMenuEvent: boolean = false;
  public menuIcon: string = '/assets/img/icon/navbar-help.svg';

  @Input() currentRoute: string;
  @Input() currentFlow: string;
  @Output() clickMenu = new EventEmitter<boolean>();

  public ROUTES = ROUTES;

  constructor(private _utilService: UtilService, private _appFacade: AppFacade) {}

  public onClickMenu() {
    this.clickEvent = !this.clickEvent;
    this.clickMenu.emit(this.clickEvent);
  }
}
